
const isInt = (n) => {
	return Number(n) === n && n % 1 === 0;
}
const format_number = (n) => {
	let result =  isInt(n)? n : (Math.round((n + Number.EPSILON) *100)/100).toFixed(2);
	// remove extra decimal zeros , example: 299.00  
	return isInt(+result)? parseInt(result): result;
}

const exclude_vat = (vat_total, vat_percentage) => {
	if (!vat_percentage) return vat_total;
	let res = vat_total / (1+vat_percentage);
	return format_number(res);
}

const add_vat = (vat_total, vat_percentage) => {
	let res = vat_total * (1+vat_percentage);
	return format_number(res);
}

export {
    add_vat,
    exclude_vat,
	format_number
} 